import moment from "moment-timezone";

export const checkIfObject = (input) => {
	if (typeof input === "object" && input !== null && !Array.isArray(input)) {
		return true;
	} else return false;
}

export const checkIfArray = (input) => {
	if (typeof input === "object" && input !== null && Array.isArray(input)) {
		return true;
	} else return false;
}

export const checkIfObjectHasKeys = (input) => {
	if (checkIfObject(input)) {
		if (Object.entries(input).length > 0) return true;
		else return false;
	} else return false;
}
